/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form } from 'antd';
import { formattedAccountList } from 'components/shared/AccountDropdown';
import useDynamicForm from 'hooks/useDynamicForm';
import useOssixProviders from 'hooks/useOssixProviders';
import { IOssixProvider } from 'interfaces/otherInterface/dynamicInput';
import { IAccountInfo } from 'interfaces/queries/account';
import CashWithdraw from 'pages/bank/Accounts/CashWithdraw/index';
import { userAccountNumbers } from 'queries/ossix/wallet/requestWallet';
import { useEffect, useState } from 'react';
import { ActionType, TargetType } from 'types/generalType';

interface CashWithdrawContainerProps {
  isDrawerOpen: any;
  handleCloseOpenDrawer: () => void;
}

const CashWithdrawContainer: React.FC<CashWithdrawContainerProps> = ({
  isDrawerOpen,
  handleCloseOpenDrawer,
}) => {
  const [form] = Form.useForm();
  const [step, setStep] = useState(1);
  const [accountNumber, setAccountNumber] = useState();
  const { loadUserAccountNumbers, accountNumbers } =
    userAccountNumbers();
  const accountNumbersInfo: IAccountInfo[] = accountNumbers;
  const selectAccountNumber = formattedAccountList(
    accountNumbersInfo,
  );
  const [selectedProvider, setSelectedProvider] = useState<
    IOssixProvider | undefined
  >();

  const onPrevious = () => setStep((prevStep) => prevStep - 1);

  const handleBackClick = () => {
    setStep(1);
    clearTransferConfirmation();
    clearCashWithdraw();
  };

  const {
    contextHolder,
    onHandleValueChange,
    loadTransferConfirmation,
    transferConfirmationData,
    onPINValuesChange,
    onHandleConfirmTransfer,
    loadSendFundsToGateway,
    onHandleCashWithdrawTransferConfirmation,
    onHandleCashBackRequest,
    onHandleClosePartnerResponseModal,
    openPartnerResponseModal,
    loadCashBack,
    partnerResponseData,
    clearCashWithdraw,
    clearTransferConfirmation,
    userData,
  } = useDynamicForm({
    accountNumber: accountNumber,
    nextStep: setStep,
    form: form,
    handleBackClick: handleBackClick,
    accountNumberCurrency: selectAccountNumber?.[0]?.currency,
    provider: selectedProvider,
  });

  const { providers, loadingProviders } = useOssixProviders({
    ActionType: ActionType.Transfer,
    CountryCode: userData?.[0]?.CountryCode,
    IncludeSelf: 'SELF',
    TargetType: TargetType.Bank,
  });

  useEffect(() => {
    if (accountNumber && !loadingProviders) {
      const filteredProvider = providers?.find(
        (item: { ShortName: string }) => item.ShortName === 'AGB',
      );
      setSelectedProvider(filteredProvider);
    }
  }, [accountNumber, loadingProviders]);

  return (
    <>
      {contextHolder}
      <CashWithdraw
        form={form}
        step={step}
        onPrevious={onPrevious}
        userData={accountNumbers}
        loadingAccount={loadUserAccountNumbers}
        setAccountNumber={setAccountNumber}
        selectAccountNumber={selectAccountNumber}
        accountNumber={accountNumber}
        isDrawerOpen={isDrawerOpen}
        handleCloseOpenDrawer={handleCloseOpenDrawer}
        dynamicFormItem={{
          contextHolder: contextHolder,
          onHandleValueChange: onHandleValueChange,
          loadTransferConfirmation: loadTransferConfirmation,
          transferConfirmationData: transferConfirmationData,
          onPINValuesChange: onPINValuesChange,
          onHandleConfirmTransfer: onHandleConfirmTransfer,
          loadSendFundsToGateway: loadSendFundsToGateway,
          onHandleCashWithdrawTransferConfirmation,
          onHandleCashBackRequest,
          loadCashBack,
          onHandleClosePartnerResponseModal,
          openPartnerResponseModal,
          partnerResponseData,
          handleBackClick,
        }}
      />
    </>
  );
};

export default CashWithdrawContainer;
